(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('voce-bilancio', {
            parent: 'entity',
            url: '/voce-bilancio?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.voceBilancio.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/voce-bilancio/voce-bilancios.html',
                    controller: 'VoceBilancioController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('voceBilancio');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('voce-bilancio-detail', {
            parent: 'entity',
            url: '/voce-bilancio/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.voceBilancio.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/voce-bilancio/voce-bilancio-detail.html',
                    controller: 'VoceBilancioDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('voceBilancio');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'VoceBilancio', function($stateParams, VoceBilancio) {
                    return VoceBilancio.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'voce-bilancio',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('voce-bilancio-detail.edit', {
            parent: 'voce-bilancio-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/voce-bilancio/voce-bilancio-dialog.html',
                    controller: 'VoceBilancioDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['VoceBilancio', function(VoceBilancio) {
                            return VoceBilancio.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('voce-bilancio.new', {
            parent: 'voce-bilancio',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/voce-bilancio/voce-bilancio-dialog.html',
                    controller: 'VoceBilancioDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                esercizio: null,
                                visualizza: false,
                                codice: null,
                                codiceEsteso: null,
                                descrizione: null,
                                utenteCreazione: null,
                                dataCreazione: null,
                                utenteAggiornamento: null,
                                dataAggiornamento: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('voce-bilancio', null, { reload: 'voce-bilancio' });
                }, function() {
                    $state.go('voce-bilancio');
                });
            }]
        })
        .state('voce-bilancio.edit', {
            parent: 'voce-bilancio',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/voce-bilancio/voce-bilancio-dialog.html',
                    controller: 'VoceBilancioDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['VoceBilancio', function(VoceBilancio) {
                            return VoceBilancio.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('voce-bilancio', null, { reload: 'voce-bilancio' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('voce-bilancio.delete', {
            parent: 'voce-bilancio',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/voce-bilancio/voce-bilancio-delete-dialog.html',
                    controller: 'VoceBilancioDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['VoceBilancio', function(VoceBilancio) {
                            return VoceBilancio.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('voce-bilancio', null, { reload: 'voce-bilancio' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
